import emoji from '/components/emoji';

export default function CountryFact({
  category,
  value,
  externalLink,
  icon,
  noBorder,
}) {
  return (
    <tr
      className={
        noBorder
          ? ''
          : ' tw-border-0 tw-border-t tw-border-solid tw-border-white/10'
      }
    >
      <td className="tw-w-36 tw-py-2">
        <strong className="tw-font-semibold">
          {icon && <span className="tw-pr-2">{emoji(icon)}</span>}
          {externalLink ? (
            <a
              rel="noopener noreferrer nofollow"
              target="_blank"
              href={externalLink}
            >
              {category}
            </a>
          ) : (
            category
          )}
        </strong>{' '}
      </td>
      <td className="tw-text-right tw-py-2">
        {externalLink ? (
          <a
            rel="noopener noreferrer nofollow"
            target="_blank"
            href={externalLink}
          >
            {value}
          </a>
        ) : (
          value
        )}
      </td>
    </tr>
  );
}
